import { Grid, Box, Typography } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import styles from './not-found.module.scss'

const NotFound = () => {
    return <>
        <Header />

        <Grid className='content' container>
            <Box className={styles.wrapper}>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="h6" color='#242333' fontWeight={700}>Not Found</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: 'center', mt: 2 }}>
                    Page you are looking for is deleted or moved
                </Box>
            </Box>

        </Grid>

        <Footer />
    </>;
}

export default NotFound;